/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PaymentMethodSelect/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaSelectOne from 'DesignSystem/TysiaSelectOne/index'
import TysiaSelectOneArrow from 'DesignSystem/TysiaSelectOne/TysiaSelectOneArrow/index'
import TysiaSelectOneContent from 'DesignSystem/TysiaSelectOne/TysiaSelectOneContent/index'
import TysiaSelectOneHeader from 'DesignSystem/TysiaSelectOne/TysiaSelectOneHeader/index'
import TysiaSelectOneInput from 'DesignSystem/TysiaSelectOne/TysiaSelectOneInput/index'
import TysiaSelectOneLabel from 'DesignSystem/TysiaSelectOne/TysiaSelectOneLabel/index'
import TysiaSelectOneOptions from 'DesignSystem/TysiaSelectOne/TysiaSelectOneOptions/index'
import TysiaSelectOnePopover from 'DesignSystem/TysiaSelectOne/TysiaSelectOnePopover/index'



/** @type {import('Simple/types.js').View} */
export default function PaymentMethodSelect({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/PaymentsPostPayment/Content/Content/Content/PaymentMethodSelect",
  isInvalid,
  isSubmitting
  
}) {
let postPaymentInfoPaymentMethodsValueData = fromData.useDataValue({ viewPath,
context: 'post_payment_info',
path: 'payment_methods',
})
let paymentsPostPaymentPaymentMethodSelectedIdValueData = fromData.useDataValue({ viewPath,
context: 'payments_post_payment',
path: 'payment_method.selected_id',
})
let paymentsPostPaymentPaymentMethodSelectedIdIsValidData = fromData.useDataIsValid({ viewPath,
context: 'payments_post_payment',
path: 'payment_method.selected_id',
validate: fromValidate.textInputOrNumber,
required: true,
})
let paymentsPostPaymentIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'payments_post_payment',
})
let onChange = fromHelpers.useOnChange({
  children,
  viewPath,
  isInvalid,
  isSubmitting
  
})
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
  return (<React.Fragment
>
<TysiaSelectOne
  viewPath={`${viewPath}/TysiaSelectOne`}
 marginTop={0}
 isMultiChoice={false}
 onChange={onChange}
 data="post_payment_info.payment_methods"
 from={postPaymentInfoPaymentMethodsValueData}
 data="payments_post_payment.payment_method.selected_id"
 validate="/Data/validate.js textInputOrNumber"
 required={true}
 value={paymentsPostPaymentPaymentMethodSelectedIdValueData}
 invalid={!paymentsPostPaymentPaymentMethodSelectedIdIsValidData}
 data="payments_post_payment"
 disabled={paymentsPostPaymentIsSubmittingData}
>
{childProps => (
<React.Fragment>
<TysiaSelectOneHeader
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneHeader`}
>
{childProps => (
<TysiaSelectOneLabel
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneLabel`}
 text="Payment method"
/>
)}
</TysiaSelectOneHeader>
<TysiaSelectOneContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneContent`}
 backgroundColor="white"
 borderColor={dtColorsNeutral300}
>
{childProps => (
<React.Fragment>
<TysiaSelectOneInput
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneInput`}
/>
<TysiaSelectOneArrow
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneArrow`}
/>
<TysiaSelectOnePopover
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOnePopover`}
>
{childProps => (
<TysiaSelectOneOptions
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneOptions`}
/>
)}
</TysiaSelectOnePopover>
</React.Fragment>
)}
</TysiaSelectOneContent>
</React.Fragment>
)}
</TysiaSelectOne>
{children}
</React.Fragment>)
}